export const PLATFORM_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  [1]: '阿里云平台',
  [2]: '创蓝平台',
  [3]: '云浪无迹短信平台'
}

export const platformOptions = [
  {
    value: '1',
    label: '阿里云平台'
  }
]

export const tableDataSchemas = [
  {
    prop: 'appName',
    label: '短信接入方名称',
    minWidth: 80
  },
  {
    prop: 'appId',
    label: '短信接入方唯一标识',
    minWidth: 80
  },

  {
    prop: 'platform',
    label: '接入的短信平台',
    minWidth: 80
  },
  {
    prop: 'phones',
    label: '接收方手机号',
    minWidth: 80
  },
  {
    prop: 'createTime',
    label: '短信发送时间',
    minWidth: 80
  },
  {
    prop: 'params',
    label: '调用方请求参数',
    minWidth: 80
  },
  {
    prop: 'sendContent',
    label: '发送内容',
    minWidth: 80
  },
  {
    prop: 'code',
    label: 'code',
    minWidth: 40
  }
]
